module.exports = __webpack_public_path__ + "static/media/class-4.d7efc6b6.PNG";